module.exports = __webpack_public_path__ + "img/lr-cb9-1.bbd3a8ac.gif";